import React from 'react'

import { Stack, useMediaQuery } from '@mui/material'

import CancelNegativation from './CancelNegativation'
import Contact from './Contact'
import Recover from './Recover'

const ActionsButton: React.FC = () => {
  const isMobile = useMediaQuery('(max-width:600px)')

  return (
    <Stack
      direction={isMobile ? 'column' : 'row'}
      width="100%"
      justifyContent="end"
      gap={1}
    >
      <Contact />
      <CancelNegativation />
      <Recover />
    </Stack>
  )
}

export default ActionsButton
